import { mapGetters, mapActions } from 'vuex'
import ShortWeekDaysMixin from '@/dependencies/mixins/short-week-days-names'
import constants from '@/dependencies/constants'

export default {
  data() {
    return {
      times: constants.TIMES,
      STEP: 60,
      START: 360,
      END: 1440,
      referenceArr: []
    }
  },
  mixins: [ShortWeekDaysMixin],
  computed: {
    ...mapGetters({
      searchScheduleStr: 'search/searchScheduleStr',
      searchScheduleObj: 'search/searchSchedule'
    })
  },
  watch: {
    searchScheduleObj: {
      immediate: true,
      async handler(val) {
        if (val && !this.searchScheduleStr.length) {
          const strValue = this.scheduleConvertedStr(val)
          await this.setSchedule({
            schedule: val,
            scheduleStr: strValue
          })
        }
      }
    }
  },
  created() {
    this.referenceArrCreator()
  },
  methods: {
    ...mapActions({
      setSchedule: 'search/SET_SCHEDULE'
    }),
    referenceArrCreator() {
      for (let i = this.START; i < this.END; i += this.STEP) {
        this.referenceArr.push(i)
      }
    },
    scheduleConvertedStr(valObj) {
      const convertedObj = {}
      const timeArr = []

      for (const key in valObj) {
        convertedObj[this.days[key - 1]] = valObj[key]
          .map((el) =>
            el.map((elem, idx) =>
              idx === 0
                ? this.times[this.referenceArr.indexOf(elem)]
                : this.times[this.referenceArr.indexOf(elem - this.STEP)]
            )
          )
          .map((elem) => [...new Set(elem)])
      }

      for (const key in convertedObj) {
        const timeString = convertedObj[key].map((el) => el.join('-'))
        timeArr.push(`${key}:${timeString}`)
      }
      return timeArr.join('; ')
    }
  }
}
